
import React from 'react';
import { motion } from 'framer-motion';

interface BenefitCardProps {
  benefit: {
    icon: React.ReactNode;
    title: string;
    description: string;
    bgImage: string;
  };
  index: number;
}

const BenefitCard = ({ benefit, index }: BenefitCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.6 }}
      viewport={{ once: true }}
      className="relative bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 text-center group overflow-hidden"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 opacity-30 group-hover:opacity-40 transition-opacity duration-300 bg-cover bg-center bg-no-repeat rounded-2xl"
        style={{ backgroundImage: `url(${benefit.bgImage})` }}
      />
      
      {/* Content overlay */}
      <div className="relative z-10">
        <motion.div
          className="flex justify-center mb-6"
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.3 }}
        >
          {benefit.icon}
        </motion.div>
        <h3 className="text-2xl font-semibold text-gray-900 mb-4">
          {benefit.title}
        </h3>
        <p className="text-gray-600 leading-relaxed">
          {benefit.description}
        </p>
      </div>
    </motion.div>
  );
};

export default BenefitCard;
